export function FieldRow({
  label,
  value,
  bold,
  accent,
}: {
  label: string
  value: React.ReactNode
  bold?: boolean
  accent?: boolean
}) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-baseline py-3 border-b border-rule last:border-0 gap-1.5 sm:gap-6">
      <span className="w-full sm:w-44 shrink-0 text-[10px] sm:text-[11px] tracking-[0.08em] uppercase text-ink-muted font-semibold">
        {label}
      </span>
      <span
        className={`text-[14px] flex-1 min-w-0 max-w-full break-words tab-nums ${
          bold ? 'font-semibold text-ink text-[15px]' : ''
        } ${accent ? 'text-gold-deep font-medium' : 'text-ink-2'}`}
      >
        {value}
      </span>
    </div>
  )
}

export function FieldEditable({
  label,
  children,
}: {
  label: string
  children: React.ReactNode
}) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center py-3 border-b border-rule last:border-0 gap-2 sm:gap-6">
      <span className="w-full sm:w-44 shrink-0 text-[10px] sm:text-[11px] tracking-[0.08em] uppercase text-ink-muted font-semibold">
        {label}
      </span>
      <div className="flex-1 w-full min-w-0">{children}</div>
    </div>
  )
}
